/**
 * Module-level mirror of the active app locale.
 *
 * The locale normally lives in React context (`useLocale`), but pure utilities — date
 * formatters, selectors, helpers called outside components — can't read context. The
 * `NextIntlClientProvider` keeps this mirror in sync so those utilities still format in
 * the current language. Inside components, prefer the reactive `useLocale` / `useFormatDate`.
 */
let activeLocale = "fr"

export function setActiveLocale(locale: string): void {
  activeLocale = locale
}

export function getActiveLocale(): string {
  return activeLocale
}

const INTL_LOCALE_TAGS: Record<string, string> = {
  fr: "fr-FR",
  rw: "rw-RW",
  en: "en-US",
}

/**
 * BCP-47 tag for the active app locale, for `Intl` / `toLocaleDateString`.
 * Falls back to `en-US` for any locale without an explicit mapping.
 */
export function getActiveIntlLocale(): string {
  return INTL_LOCALE_TAGS[activeLocale] ?? "en-US"
}
